import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取党建学习列表
export function listPartyStudys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyStudy.listPartyStudys',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增党建学习
export function savePartyStudy(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyStudy.savePartyStudy',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新党建学习
export function updatePartyStudy(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyStudy.updatePartyStudy',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取党建学习详情
export function getPartyStudy(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyStudy.getPartyStudy',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
